/**
 * Reconnect backoff: exponential with equal jitter, capped. Grows 1s → 30s so
 * a Costanza deploy (~10–20s of pod-boot 503s) is ridden out within a few
 * attempts, while a longer outage settles into a gentle ~30s poll. The jitter
 * spreads the reconnect stampede when a deploy finishes and every open tab
 * notices the server is back at the same moment.
 */
const BASE_MS = 1_000
const CAP_MS = 30_000

/**
 * Delay in ms before reconnect `attempt` (0-based): half the exponential
 * window fixed, half jittered — never hammers, never waits double the cap.
 */
export const backoffDelay = (
  attempt: number,
  random: () => number = Math.random
): number => {
  const ceiling = Math.min(CAP_MS, BASE_MS * 2 ** attempt)
  return ceiling / 2 + random() * (ceiling / 2)
}
